import { KeyValue } from "../models/KeyValue";
import { RecruitmentActionType as Action } from "./constants/RecruitmentActionType";

export const RECRUITMENT_ACTION_KEY_VALUES: KeyValue[] = Object.keys(Action).map((key) => ({
	key: key,
	value: key,
}));
